import React from "react";
import {
  Flex,
  Text,
  Box,
} from "@chakra-ui/react";
import ReactEcharts from "echarts-for-react";
import Card from "components/Card/Card";
import ExportButton from "components/Reports/ExportCSV";

const TopPerformingPartnersChart = ({
  data = [],
  loading,
}) => {
  if (loading) return null;

  const chartData = data.map((item) => ({
    name: item.partner_name || "Unknown",
    value: item.commission_earned || 0,
  }));

  const option = {
    tooltip: {
      trigger: "item",
      formatter: (params) =>
        `${params.name}<br/>Commission: P${params.value.toLocaleString()}`,
    },

    legend: {
      bottom: 0,
      textStyle: {
        color: "#071D54",
      },
    },

    series: [
      {
        name: "Commission Earned",
        type: "pie",
        radius: ["45%", "70%"],

        avoidLabelOverlap: false,

        label: {
          color: "#071D54",
          formatter: "{b}\n{d}%",
        },

        emphasis: {
          label: {
            show: true,
            fontSize: 18,
            fontWeight: "bold",
          },
        },

        labelLine: {
          show: true,
        },

        data: chartData,
      },
    ],

    color: [
      "#60A5FA",
      "#376FE0",
      "#2445A8",
      "#1A388C",
      "#102A70",
      "#5AA0FF",
      "#93C5FD",
      "#BFDBFE",
    ],
  };

  const exportData = data.map((item) => ({
    Partner: item.partner_name || "Unknown",
    "Referral Code": item.referral_code,
    Recruits: item.drivers_referred,
    Commission: item.commission_earned,
  }));

  return (
    <Card
      py="1rem"
      height="400px"
      width="100%"
      bg="white"
      position="relative"
    >
      <Box
        position="absolute"
        top="12px"
        right="12px"
        zIndex="2"
      >
        <ExportButton
          data={exportData}
          fileName="top_performing_partners"
        />
      </Box>

      <Flex
        px={5}
        pt={2}
        justify="space-between"
      >
        <Text
          color="#071D54"
          fontWeight="bold"
          fontSize="lg"
        >
          Top Performing Partners
        </Text>
      </Flex>

      <ReactEcharts
        option={option}
        style={{
          height: "320px",
          width: "100%",
        }}
      />
    </Card>
  );
};

export default TopPerformingPartnersChart;